import { fetchSnapshot } from '@features/flows/runtime/snapshot';
import { useRuntimeStore } from '@features/flows/runtime/useRuntimeStore';

function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

function bestEffortExtractIO(snapshot: any, nodeId: string, kind: 'inputs'|'outputs') {
  try {
    const bus = snapshot?.snapshot?.databus ?? snapshot?.databus ?? {};
    const nodes = bus.nodes ?? {};
    const node = nodes?.[nodeId] ?? {};
    const lastKey = kind === 'inputs' ? 'lastInputs' : 'lastOutputs';
    return node[lastKey] ?? node[kind] ?? node?.last?.[kind] ?? null;
  } catch {
    return null;
  }
}

export async function downloadNodeIO({ flowId, nodeId, runId, kind, iteration }: { flowId: string; nodeId: string; runId: string; kind: 'inputs'|'outputs'; iteration?: number }) {
  const state = useRuntimeStore.getState();
  const node = state.nodes[nodeId] as any;
  // Prefer iteration-scoped previews if requested
  let data: any = undefined;
  if (typeof iteration === 'number' && node?.iterations?.[iteration]) {
    data = kind === 'inputs' ? node.iterations[iteration].inputsPreview : node.iterations[iteration].outputsPreview;
  }
  if (typeof data === 'undefined' || data == null) {
    // Fall back to latest mirrors
    data = kind === 'inputs' ? node?.lastInputsPreview : node?.lastOutputsPreview;
  }
  if (typeof data === 'undefined' || data == null) {
    // As a last resort, pull from snapshot
    const snap = await fetchSnapshot(runId);
    data = bestEffortExtractIO(snap, nodeId, kind);
  }
  if (typeof data === 'undefined' || data == null) throw new Error('No data found');
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const suffix = typeof iteration === 'number' ? `.iter-${iteration}` : '';
  const fname = `${flowId}_${nodeId}_${kind}${suffix}_${runId}.json`.replace(/[^\w.\-]/g, '_');
  saveBlob(blob, fname);
}

export function downloadNodeLogs({ flowId, nodeId, runId, iteration }: { flowId: string; nodeId: string; runId: string; iteration?: number }) {
  const nodes = useRuntimeStore.getState().nodes as Record<string, any>;
  const node = nodes[nodeId];
  const logs = typeof iteration === 'number' ? (node?.iterations?.[iteration]?.logs ?? []) : (node?.logs ?? []);
  const text = logs.map((l: any) => `[${new Date(l.t).toISOString()}] ${String(l.level || 'info').toUpperCase()} ${l.msg}`).join('\n');
  const blob = new Blob([text], { type: 'text/plain' });
  const suffix = typeof iteration === 'number' ? `.iter-${iteration}` : '';
  const fname = `${flowId}_${nodeId}_logs${suffix}_${runId}.log`.replace(/[^\w.\-]/g, '_');
  saveBlob(blob, fname);
}
